/* eslint-disable import/no-unresolved */
import axios from 'axios';

const cnpj = axios.create({
  baseURL: 'https://api.cnpja.com.br/companies',
});

export default cnpj;
